function transWidthHeight(css: any) {
    if (css === undefined || css === null) {
        return undefined;
    }
    
    // 숫자 타입이거나 숫자로만 이루어진 문자열인 경우 px 단위 추가
    if (typeof css === 'number' || (typeof css === 'string' && !isNaN(Number(css)))) {
        return `${css}px`;
    }
    
    return css;
}

export default transWidthHeight;